export const NEWS_ENTITY_NAME = 'news';
export const NEWS_SECTION_CODE = `app.${NEWS_ENTITY_NAME}`;
